'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.positionDropdown = positionDropdown;
function positionDropdown(dropdown, button, body) {
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  // Check for null / undefined in the elements and body passed in.
  if (!dropdown || !button || !body) {
    /*eslint-disable */
    console.error('Supply a dropdown list element, button element and a body element in order to get positioning.');
    return { top: 0, left: 0 };
  }

  var isRtl = document.getElementsByTagName('html')[0].dir.toLowerCase() === 'rtl';
  var bodyRect = body.getBoundingClientRect();

  var buttonRect = button.getBoundingClientRect();
  var dropdownRect = dropdown.getBoundingClientRect();
  var marginOffset = offset;

  // Button Edges Relative to Document (Scroll)
  var topButtonOffset = buttonRect.top + window.pageYOffset;
  var bottomButtonOffset = bodyRect.height - (buttonRect.top + buttonRect.height);

  // Document Top To Under Button
  var topPosition = topButtonOffset + buttonRect.height + marginOffset;
  // Document Top To Above Button (minus dropdown height to offset)
  var bottomPosition = topButtonOffset - dropdownRect.height - marginOffset;

  var hangFromRightPosition = buttonRect.right - dropdownRect.width; // hang off the right of the element.
  var leftPosition = buttonRect.left; // hang off the left of the element.
  var dropdownFallsFromLeft = leftPosition + dropdownRect.width >= bodyRect.width;
  var dropdownFallsFromRight = hangFromRightPosition < 0;

  if (buttonRect.height + dropdownRect.height + marginOffset >= bottomButtonOffset && bottomPosition > 0) {
    topPosition = bottomPosition;
  }

  if (dropdownFallsFromLeft && dropdownFallsFromRight) {
    // if the dropdown would fall off regardless of which side it's anchored,
    leftPosition = 0; // then anchor it to left of the window/page, for the best visibility.
  } else if (dropdownFallsFromLeft || isRtl && !dropdownFallsFromRight) {
    // if the dropdown would fall off the page when anchored to the left of the button or,
    // when rtl, the dropdown wouldn't fall off when anchored to the right of the button,
    leftPosition = hangFromRightPosition; // then anchor the dropdown to the right of button.
  }

  return {
    top: topPosition,
    left: leftPosition
  };
}



//////////////////
// WEBPACK FOOTER
// ../player-react-portal/build/portal-position.js
// module id = 62
// module chunks = 0